import { SubNavButtonLink, SecondaryButtonLink } from "../../atoms/Buttons";
import Grid from "../../atoms/Grid";
import Image from "next/image";
import { InternalLinkIcon, ChevronRight } from "../../atoms/Icons";
import Link from "next/link";
import { AnimatePresence, motion } from "framer-motion";
import { fadeInOut } from "../../atoms/Animations";
import MenuSecondaryNav from "./MenuSecondaryNav";
import placeholder from "../../../public/assets/placeholder.png";
import MenuOverlay from "../../atoms/MenuOverlay";
import { useRef, useEffect, useState } from "react";
import getImageFromStrapi from "../../../utils/api/getImageFromStrapi";
import { prefix } from "../../../utils/utils";
import Tabs from "../../blocks/Elements/Tabs";

export default function MenuModalSmall({
  openModalSmall,
  setOpenModalSmall,
  modalSmallActiveItem,
  setModalSmallActiveItem,
  menuItems,
  menuItemsSecondary,
  tablet_image,
}) {
  const menuOverlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  // Inicia sempre com a primeira tab ativa do submenu com mais de 1 área
  useEffect(() => {
    if (modalSmallActiveItem) {
      const activeItem = menuItems.find(
        (item) => item.id === modalSmallActiveItem,
      );
      if (activeItem && activeItem.submenu.length > 0) {
        setActiveSubmenu(activeItem.submenu[0].area);
      }
    } else {
      setActiveSubmenu(null);
    }
  }, [modalSmallActiveItem, menuItems]);

  useEffect(() => {
    if (openModalSmall) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
      const timer = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timer);
    }
  }, [openModalSmall]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpenModalSmall(false);
      }
    };

    const handleClickOutside = (event) => {
      if (
        menuOverlayRef.current &&
        menuOverlayRef.current.contains(event.target)
      ) {
        setOpenModalSmall(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      {shouldRender && (
        <div
          ref={menuOverlayRef}
          className={`
            menu-overlay hidden 640:block fixed inset-0 top-40 bg-[#303337]/50
            transition-opacity duration-300 ease-in-out
            ${isVisible ? "opacity-100" : "opacity-0"}
          `}
        ></div>
      )}

      {shouldRender && (
        <div
          className={`menu-modal-sm container-custom 1024:hidden bg-gray-200 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <Grid extraClass="overflow-y-auto h-full pt-20 640:py-32">
            <div className="col-span-4 640:col-span-3 1024:col-span-6 flex flex-col justify-between">
              {modalSmallActiveItem ? (
                <ul className="flex flex-col gap-y-32">
                  <li>
                    <button
                      onClick={() => setModalSmallActiveItem(null)}
                      className="flex items-center gap-x-15 text-xxs font-semibold"
                      aria-label="Back"
                    >
                      <ChevronRight extraClass="stroke-theme-color rotate-180" />
                      {menuItems.find(
                        (item) => item.id === modalSmallActiveItem,
                      )?.title || "Back"}
                    </button>
                  </li>
                  {menuItems.map((item, index) => {
                    if (item.id === modalSmallActiveItem) {
                      return (
                        <div key={index}>
                          {item.submenu.length > 1 ? (
                            <>
                              <Tabs
                                tabs={item.submenu}
                                activeSubmenu={activeSubmenu}
                                setActiveSubmenu={setActiveSubmenu}
                              />
                              {item.submenu.map(
                                (area, index) =>
                                  activeSubmenu === area.area && (
                                    <div key={index} className="mt-17">
                                      {area.items.map((subItem, subIndex) => (
                                        <li
                                          key={subIndex}
                                          className="py-14 border-t border-gray-300"
                                        >
                                          <SubNavButtonLink
                                            text={subItem.title}
                                            href={subItem.slug}
                                            onClick={() => {
                                              setOpenModalSmall(false);
                                              setModalSmallActiveItem(null);
                                            }}
                                          />{" "}
                                        </li>
                                      ))}
                                      {area.viewAll && area.viewAll.slug ? (
                                        <SecondaryButtonLink
                                          href={area.viewAll.slug}
                                          text={area.viewAll.title}
                                          onClick={() => {
                                            setOpenModalSmall(false);
                                            setModalSmallActiveItem(null);
                                          }}
                                          extraClass="mt-20"
                                          icon={
                                            <InternalLinkIcon extraClass="stroke-theme-color !w-20 !h-20" />
                                          }
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  ),
                              )}
                            </>
                          ) : (
                            item.submenu.map((area, index) => (
                              <div
                                key={index}
                                className={index > 0 ? "mt-32" : ""}
                              >
                                <span className="block text-12 font-medium uppercase text-gray-600 mb-32">
                                  {area.area}
                                </span>
                                {area.items.map((subItem, subIndex) => (
                                  <li
                                    key={subIndex}
                                    className="py-14 border-t border-gray-300"
                                  >
                                    <SubNavButtonLink
                                      text={subItem.title}
                                      href={subItem.slug}
                                      onClick={() => {
                                        setOpenModalSmall(false);
                                        setModalSmallActiveItem(null);
                                      }}
                                    />{" "}
                                  </li>
                                ))}
                                {area.viewAll && area.viewAll.slug ? (
                                  <SecondaryButtonLink
                                    href={area.viewAll.slug}
                                    text={area.viewAll.title}
                                    onClick={() => {
                                      setOpenModalSmall(false);
                                      setModalSmallActiveItem(null);
                                    }}
                                    extraClass="mt-20"
                                    icon={
                                      <InternalLinkIcon extraClass="stroke-theme-color !w-20 !h-20" />
                                    }
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            ))
                          )}
                        </div>
                      );
                    }
                    return null;
                  })}
                </ul>
              ) : (
                <ul className="flex flex-col 1024:hidden divide-y divide-gray-300">
                  {menuItems.length > 0 &&
                    menuItems.map((item, index) => (
                      <li key={index} className="py-14">
                        {item.submenu ? (
                          <button
                            type="button"
                            aria-label={item.title || ""}
                            onClick={() => setModalSmallActiveItem(item.id)}
                            className="flex items-center justify-between w-full"
                          >
                            <span className="text-xxs font-medium">
                              {item.title}
                            </span>
                            <ChevronRight extraClass="stroke-theme-color" />
                          </button>
                        ) : (
                          <Link
                            href={prefix(item.slug)}
                            as={prefix(item.slug)}
                            onClick={() => {
                              setOpenModalSmall(false);
                              setModalSmallActiveItem(null);
                            }}
                            className="text-xxs font-medium"
                            aria-label={item.title}
                          >
                            {item.title}
                          </Link>
                        )}
                      </li>
                    ))}
                </ul>
              )}
              <MenuSecondaryNav menuItemsSecondary={menuItemsSecondary} />
            </div>
            <div className="hidden 640:inline 640:col-span-3 1024:col-span-6 relative aspect-[4/5] rounded-xxxs overflow-hidden">
              {modalSmallActiveItem ? (
                <Image
                  src={
                    menuItems.find((item) => item.id === modalSmallActiveItem)
                      ?.image
                  }
                  fill
                  sizes="50vw"
                  className="w-full h-full object-cover"
                  alt=""
                />
              ) : (
                <Image
                  src={
                    tablet_image
                      ? getImageFromStrapi(tablet_image)
                      : placeholder
                  }
                  fill
                  sizes="50vw"
                  className="w-full h-full object-cover"
                  alt=""
                />
              )}
            </div>
          </Grid>
        </div>
      )}
    </>
  );
}
